import React from "react";
import { Row } from "react-bootstrap";
import { SliderPanel } from "../../../components";
import { MAPPER_PLAN_STATUS } from "../../../utils";

const MappedPlanGroupSliderData = (props) => {
  const { item } = props;

  return (
    <div className="sliderCard">
      <div className="d-flex flex-row" style={{ marginLeft: "-10px" }}>
        {MAPPER_PLAN_STATUS[item.status] === "In Active" ? (
          <div className="tile-line gray"></div>
        ) : MAPPER_PLAN_STATUS[item.status] === "Active" ? (
          <div className="tile-line green"></div>
        ) : MAPPER_PLAN_STATUS[item.status] === "Terminated" ? (
          <div className="tile-line red"></div>
        ) : MAPPER_PLAN_STATUS[item.status] === "UnderConstruction" ? (
          <div className="tile-line orange"></div>
        ) : MAPPER_PLAN_STATUS[item.status] === "Approved" ? (
          <div className="tile-line darkgreen"></div>
        ) : MAPPER_PLAN_STATUS[item.status] === "ReadyFor" ? (
          <div className="tile-line blue"></div>
        ) : null}
        <div
          className="d-flex flex-col"
          style={{ padding: "10px 10px 0 10px" }}
        >
          <p className="ft-14 mb-1 fw-500">{item.name}</p>
          <div className="mt-1 d-flex flex-row">
            <p className="ft-12 mb-0">{item.rkPlanNumber}</p>

            {MAPPER_PLAN_STATUS[item.status] === "InActive" ? (
              <span className="tile-state-gray">
                {MAPPER_PLAN_STATUS[item.status]}
              </span>
            ) : MAPPER_PLAN_STATUS[item.status] === "Active" ? (
              <span className="tile-state-green">
                {MAPPER_PLAN_STATUS[item.status]}
              </span>
            ) : MAPPER_PLAN_STATUS[item.status] === "Terminated" ? (
              <span className="tile-state-red">
                {MAPPER_PLAN_STATUS[item.status]}
              </span>
            ) : MAPPER_PLAN_STATUS[item.status] === "UnderConstruction" ? (
              <span className="tile-state-orange w-100">
                {MAPPER_PLAN_STATUS[item.status]}
              </span>
            ) : MAPPER_PLAN_STATUS[item.status] === "ReadyFor" ? (
              <span className="tile-state-blue">
                {MAPPER_PLAN_STATUS[item.status]}
              </span>
            ) : MAPPER_PLAN_STATUS[item.status] === "Approved" ? (
              <span className="tile-state-darkgreen">
                {MAPPER_PLAN_STATUS[item.status]}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MappedPlanGroupSliderData;
